import { render, staticRenderFns } from "./demo-blank.vue?vue&type=template&id=458ca498&scoped=true&"
import script from "./demo-blank.vue?vue&type=script&lang=js&"
export * from "./demo-blank.vue?vue&type=script&lang=js&"
import style0 from "./demo-blank.vue?vue&type=style&index=0&id=458ca498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ca498",
  null
  
)

export default component.exports